import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useBookStore } from '../../provider/BookStore';



const Navbar = (props) => {

  const navigate = useNavigate();

  const styleNavBar = {
    position: "fixed",
    height: '70px',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1,
  }
  
  const styleButtonAdd = {
    position: "fixed",
    bottom: '90px',
    right: '20px',
    width: '60px',
    height: '60px',
    borderRadius: '100px',
    textAlign: 'center',
    marginTop: '-25px',
    fontSize: '1.6rem',
    boxShadow: '0 .0625em .125em rgba(10,10,10,.05)',
    zIndex: 2,
  }

  return (

    <div className='container is-max-widescreen mb-6'>
      
      <nav className='is-floating-navbar has-background-primary-15 has-text-white'>
        <div className='is-clearfix mb-0 pl-5 pr-5 pt-3 pb-3 '>
          {/* {renderHome()} */}
          {/* <p className='is-size-5 is-pulled-left'>Bottom</p> */}
          {/* {renderElement()} */}
          <div className='columns is-mobile'>
            <button className='column' onClick={()=>{navigate('/transactions')}}>
              <i className="fa fa-list-alt"></i>
              <p className='is-size-7'>Transaksi</p>
            </button>
            <button className='column' onClick={()=>{navigate('/statistics')}}>
              <i className="fa fa-bar-chart" ></i>
              <p className='is-size-7'>Statistik</p>
            </button>
            {/* <div className='column'>

            <button style={styleButtonAdd} className='has-background-primary' onClick={()=>addTransaction()}>
              <i  className="fa fa-plus"></i>
            </button>
            </div> */}
            {/* <button className='column' onClick={()=>{navigate('/pocket')}}>
              <i className="fa fa fa-credit-card"></i>
              <p className='is-size-7'>Dompet</p>
            </button> */}
            <button className='column' onClick={()=>{navigate('/book')}}>
              <i className="fa fa-sliders" ></i>
              <p className='is-size-7'>Pengatur</p>
            </button>
          </div>
        </div>

      </nav>
    </div>
  )
}

export default Navbar
